import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { GameLogItemProps } from "./types";
import { useLeagueLogo } from "../../data/LeagueEnvironmentProvider";
import "../teamReportDesign.scss";

const resultOf = ({ isHome, homeScore, awayScore }: GameLogItemProps) => {
  const us = isHome ? homeScore : awayScore;
  const them = isHome ? awayScore : homeScore;
  return {
    wl: us > them ? "W" : us < them ? "L" : "",
    score: `${us}-${them}`,
  };
};

/**
 * The 1C game log: five clickable cards on the web (each opens that game's
 * report), a one-line five-cell strip in print. One component renders both;
 * the visibility helpers pick per medium.
 */
export default function GameLogCards({ games }: { games: GameLogItemProps[] }) {
  const getTeamLogoUrl = useLeagueLogo();

  return (
    <div className="trd">
      <div className="glog trd-webonly" style={{ display: "grid" }}>
        {games.map((game, index) => {
          const { wl, score } = resultOf(game);
          const date = dayjs(game.date);
          const clickable = game.reportAvailable && game.gameId;
          const card = (
            <>
              <div className="gd">
                <span>{date.format("MMM D").toUpperCase()}</span>
                <span>{date.format("ddd").toUpperCase()}</span>
              </div>
              <div className="opp">
                <span
                  className="glogo"
                  style={{
                    backgroundImage: `url(${getTeamLogoUrl(game.opponentInfo.nba_id)})`,
                  }}
                />
                <span className="vs">{game.isHome ? "VS" : "@"}</span>
                <span className="ab">{game.opponentInfo.abbrev}</span>
                <span className="nm2">{game.opponentInfo.name}</span>
              </div>
              <div className="res">
                <span className={wl === "L" ? "wl l" : "wl"}>{wl}</span>
                <span>{score}</span>
                <span className="arr">→</span>
              </div>
            </>
          );
          return clickable ? (
            <Link
              key={index}
              className="gcard"
              to={`?report=${game.teamAbbrev}-game-${game.gameId}`}
              title="Open single-game report"
            >
              {card}
            </Link>
          ) : (
            <a key={index} className="gcard off" href="#log">
              {card}
            </a>
          );
        })}
      </div>
      <div className="trd-printonly">
        <div className="glogp">
          {games.map((game, index) => {
            const { wl, score } = resultOf(game);
            return (
              <div className="gc" key={index}>
                <div className="d">
                  {dayjs(game.date).format("MMM D").toUpperCase()} ·{" "}
                  {game.isHome ? "VS" : "@"} {game.opponentInfo.abbrev}
                </div>
                <div className="r">
                  <span className={wl === "L" ? "wl l" : "wl"}>{wl}</span>
                  <span>{score}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
